import { useContext } from "react";
import { KBContext, AutherContext } from "../../Context";

export const useApiAccess = () => {
    const { data } = useContext(KBContext);
    const { isProfileMeDone } = useContext(AutherContext);
  
    const shouldGetCategory = data?.isInternal ? isProfileMeDone : true;
    const hasApiAccess = Object.keys(data)?.length > 0 && shouldGetCategory;

    return hasApiAccess;
}